
import React from 'react';
import { MessageCircle, Crown } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface MessageLimitIndicatorProps {
  currentCount: number;
  limit: number;
  remaining: number;
  isLoading: boolean;
  planType: string;
}

export const MessageLimitIndicator: React.FC<MessageLimitIndicatorProps> = ({
  currentCount,
  limit,
  remaining,
  isLoading,
  planType
}) => {
  // Não mostrar nada se ilimitado ou carregando
  if (isLoading || limit === -1) {
    return null;
  }

  const isNearLimit = remaining <= 1;
  const isAtLimit = remaining === 0;

  return (
    <div className="flex items-center justify-center py-2">
      <div className="flex items-center gap-2 text-sm">
        <MessageCircle className="h-4 w-4 text-luxury-red" />
        
        <span className={`font-medium ${isAtLimit ? 'text-red-400' : isNearLimit ? 'text-yellow-400' : 'text-gray-300'}`}>
          Mensagens restantes hoje: {remaining}/{limit}
        </span>
        
        <Badge variant="outline" className="border-luxury-red text-luxury-red text-xs">
          {planType === 'sponsor_free' ? 'Free' : planType}
        </Badge>

        {isNearLimit && (
          <div className="flex items-center gap-1 text-xs text-yellow-400">
            <Crown className="h-3 w-3" />
            <span>Upgrade para ilimitado</span>
          </div>
        )}
      </div>
    </div>
  );
};
